import { map } from 'lodash';
import { makeObservable, observable, computed } from 'mobx';
import {
  IIntakePetSectionQuestionListValue,
  IntakePetSectionQuestionListValue,
  IPhotoModel,
  PhotoModel,
} from '.';
import { ISyncModel, SyncModel } from '@common/models/SyncModel';

export interface IIntakePetSectionQuestionModel extends ISyncModel {
  intakePetSectionQuestionId: number;
  intakePetSectionId: number;
  questionId: number;
  questionTypeId: number;
  name: string;
  followupQuestion: string;
  showFollowupWhenAnswerIs: boolean;
  allowMultiple: boolean;
  isReadOnly: boolean;
  sortOrder: number;
  stringValue: string;
  bitValue?: boolean;
  photoId?: number;
  yesOverrideText: string;
  noOverrideText: string;
  useMultiChoiceDropDown: boolean;
  isFollowupReadOnly: boolean;
  intakePetSectionQuestionListValues: IIntakePetSectionQuestionListValue[];
  photo?: IPhotoModel;
  questionSummary: string;
  rowVersion: string;
}

export class IntakePetSectionQuestionModel
  extends SyncModel
  implements IIntakePetSectionQuestionModel
{
  @observable intakePetSectionQuestionId = 0;
  @observable intakePetSectionId = 0;
  @observable questionId = 0;
  @observable questionTypeId = 0;
  @observable name = '';
  @observable followupQuestion = '';
  @observable showFollowupWhenAnswerIs = false;
  @observable allowMultiple = false;
  @observable isReadOnly = false;
  @observable sortOrder = 0;
  @observable stringValue = '';
  @observable bitValue?: boolean;
  @observable photoId?: number;
  @observable yesOverrideText = '';
  @observable noOverrideText = '';
  @observable useMultiChoiceDropDown = false;
  @observable isFollowupReadOnly = false;
  @observable
  intakePetSectionQuestionListValues: IntakePetSectionQuestionListValue[] = [];
  @observable photo?: PhotoModel;
  @observable questionSummary = '';

  constructor(params: Partial<IIntakePetSectionQuestionModel> = {}) {
    const {
      intakePetSectionQuestionId = 0,
      intakePetSectionId = 0,
      questionId = 0,
      questionTypeId = 0,
      name = '',
      followupQuestion = '',
      showFollowupWhenAnswerIs = false,
      allowMultiple = false,
      isReadOnly = false,
      sortOrder = 0,
      stringValue = '',
      bitValue = undefined,
      photoId = undefined,
      yesOverrideText = '',
      noOverrideText = '',
      useMultiChoiceDropDown = false,
      isFollowupReadOnly = false,
      intakePetSectionQuestionListValues = [] as Array<IntakePetSectionQuestionListValue>,
      photo = undefined,
      questionSummary = '',
      rowVersion = '',
    } = params;
    super(params);
    this.intakePetSectionQuestionId = intakePetSectionQuestionId;
    this.intakePetSectionId = intakePetSectionId;
    this.questionId = questionId;
    this.questionTypeId = questionTypeId;
    this.name = name;
    this.followupQuestion = followupQuestion;
    this.showFollowupWhenAnswerIs = showFollowupWhenAnswerIs;
    this.allowMultiple = allowMultiple;
    this.isReadOnly = isReadOnly;
    this.sortOrder = sortOrder;
    this.stringValue = stringValue;
    this.bitValue = bitValue;
    this.photoId = photoId;
    this.yesOverrideText = yesOverrideText;
    this.noOverrideText = noOverrideText;
    this.useMultiChoiceDropDown = useMultiChoiceDropDown;
    this.isFollowupReadOnly = isFollowupReadOnly;
    map(intakePetSectionQuestionListValues, (lv) => {
      this.intakePetSectionQuestionListValues.push(
        new IntakePetSectionQuestionListValue(lv),
      );
    });
    this.photo = photo;
    this.questionSummary = questionSummary;
    this.rowVersion = rowVersion;

    makeObservable(this);
  }

  @computed
  get selectedListValueId(): number | undefined {
    return this.intakePetSectionQuestionListValues.find((lv) => lv.isSelected)
      ?.intakePetSectionQuestionListValueId;
  }

  @computed
  get sortedListValues(): IntakePetSectionQuestionListValue[] {
    return this.intakePetSectionQuestionListValues
      .slice()
      .sort((a, b) => a.sortOrder - b.sortOrder);
  }

  @computed get photoUrl() {
    return this.photo ? this.photo.photoUrl : '';
  }

  // static GetIntakePetSectionQuestionModelFromQuestion(question: IQuestionModel) {
  //     return new IntakePetSectionQuestionModel({ ...question as IQuestionModel,
  //         questionId: 0,
  //         questionTypeId: question.questionTypeId,
  //         name: question.name,
  //         isReadOnly: question.isReadOnly,
  //         isFollowupReadOnly: question.isFollowupReadOnly,
  //         followupQuestion: question.followupQuestion,
  //         showFollowupWhenAnswerIs: question.showFollowupWhenAnswerIs,
  //         allowMultiple: question.allowMultiple,
  //         yesOverrideText: question.yesOverrideText
  //     })
  // }
}
